import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ControlPannel from "./ControlPannel";
import CustomLink from "./CustomLink";
import { getBearerToken, isAdmin, Page, dynamicResourceLinks } from "./util";
import $ from 'jquery'
import { string as toStyleString } from 'to-style'
import ReactDOM from 'react-dom';

var integer = 0
var settimeoutid = -1

var deleteCallback = () => {
	console.log("del callback in vein")
}

function loadingMessage(elid) {
	var rem = 7
	ReactDOM.render(
		<div className="message" style={{
		}}>
			{"Deleting\u00A0" + String("\u00A0".repeat(5) + "..." + "\u00A0".repeat(5)).substring(rem - integer, 5 + rem - integer)}
		</div>, document.getElementById(elid)
	)
	integer += 1
	integer %= rem
	settimeoutid = setTimeout(() => { loadingMessage(elid) }, 75)
}

const Users = () => {
	let navigate = useNavigate();
	const [userstable, setuserstable] = useState();
	const [wm, setwm] = useState(0);

	useEffect(() => {
		if (isAdmin())
			axios.get("https://api.pcbang.ma/api/users?populate=role",
				{
					headers: {
						Authorization: getBearerToken()
					}
				}
			).then((res) => {
				console.log(res)
				var tr = res.data.map(user => {
					return <tr className="row" key={user.id} onClick={() => {
						navigate("/profile?user=" + user.username, { replace: true })
					}}>
						<td className="td-id">{user.id}</td>
						<td className="td-text td-username">{user.username}</td>
						<td className="td-text td-authorname">{user.name}</td>
						<td className="td-text td-role">{user.role.name}</td>
						<td className="td-text td-email">{user.email}</td>
						<td className="td-delete">
							<div className="flex-jc-cr flex-ai-cr w100 h100">
								{
									user.role.type !== "admin" ?
										<img src={dynamicResourceLinks("ffffff").trashCanIcon} alt="" className="deleteicon" /**style={{ position: "relative", zIndex: "5" }} */
											onClick={(e) => {
												console.log("test clicked delete")
												e.stopPropagation()
												$("#confirm-delete").attr("style", toStyleString({ position: "fixed" }))
												deleteCallback = () => {
													console.log("delete user number: " + user.id)
													axios.delete("https://api.pcbang.ma/api/users/" + user.id.toString(),
														{
															headers: {
																Authorization: getBearerToken()
															}
														}
													).then((res) => {
														console.log(res)
														clearTimeout(settimeoutid)
														ReactDOM.render(<div className='message' style={{ color: "lime", width: "unset" }}>Done!</div>, document.getElementById("delete-message"))
														setTimeout(() => {
															setwm(wm + 1)
														}, 0)
													}).catch((err) => {
														console.log(err)
														clearTimeout(settimeoutid)
														ReactDOM.render(<div className='message' style={{ color: "red", width: "unset" }}>{err.toString()}</div>, document.getElementById("delete-message"))
													})
												}
												return false
											}}
										/>
										: <></>
								}
							</div>
						</td>
					</tr>
				})
				setuserstable(tr)
			}).catch((err) => {
				console.log(err)
			})
	}, [wm, navigate])
	if (!isAdmin()) {
		return (
			<Page className="users">
				<div className="navpad h50"></div>
				<div>Admins Only</div>
			</Page>
		)
	}
	return (
		<>
			<div id="confirm-delete" className='flex-jc-cr flex-column flex-ai-cr' style={{ display: "none" }}>
				<p className="text">
					Are you sure you want to delete this user? <br></br>
					This action is irreversable.
				</p>
				<div className="button-container flex-jc-cr flex-ai-cr">
					<button className="util-button confirm"
						onClick={() => {
							$("#confirm-delete").attr("style", toStyleString({ display: "none" }))
							// var st_id = -1
							loadingMessage("delete-message")
							// console.log({jsblog}, "clicked and confirmed delete")
							// return

							deleteCallback()
							// axios.delete("https://api.pcbang.ma/api/articles/" + jsblog.id.toString(),
							// 	{
							// 		headers: {
							// 			Authorization: getBearerToken()
							// 		}
							// 	}
							// ).then((res) => {
							// 	console.log(res)
							// 	clearTimeout(settimeoutid)
							// 	ReactDOM.render(<div className='message' style={{ color: "lime", width: "unset" }}>Done!</div>, document.getElementById("delete-message"))
							// }).catch((err) => {
							// 	console.log(err)
							// 	clearTimeout(settimeoutid)
							// 	ReactDOM.render(<div className='message' style={{ color: "red", width: "unset" }}>{err.toString()}</div>, document.getElementById("delete-message"))
							// })

						}}
					>Confirm</button>
					<button className="util-button cancel"
						onClick={() => {
							$("#confirm-delete").attr("style", toStyleString({ display: "none" }))
						}}
					>Cancel</button>
				</div>
			</div>
			<div className="pagebody users">
				<div className="mainbody">
					<div className="navpad h50">
					</div>
					<ControlPannel >
						<div id="delete-message"></div>
						<CustomLink className="newblog right"
							to={"/create-new-user"}
						// {...mouseEventStyles(
						// 	{ backgroundColor: "rgba(255, 255, 255, 0.2)" },
						// 	{ backgroundColor: "rgba(255, 255, 255, 0.3)" }
						// )}
						>
							<div className="plus">+</div>
							<div className="tooltip">
								create new user
							</div>
						</CustomLink>
					</ControlPannel>
					<div className="flex-column flex-ai-cr w100 tablecontainer">
						<table border="1" frame="void" rules="rows">
							<thead>
								<tr>
									<th className="td-id">ID</th>
									<th className="th-user">User<wbr></wbr>name</th>
									<th className="th-author">Author Name</th>
									<th className="th-role">Role</th>
									<th className="th-email">Email</th>
									<th className="td-delete">Delete</th>
								</tr>
							</thead>
							<tbody>
								{
									userstable
								}
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</>
	);
}

export default Users;